import React from "react";
import { Link } from "react-router-dom";

const SiteFooter: React.FC = () => (
  <footer
    style={{
      background: "var(--nx-navy2)",
      borderTop: "1px solid rgba(255,255,255,0.05)",
      padding: "40px 5%",
    }}
  >
    <div
      style={{
        maxWidth: 1100,
        margin: "0 auto",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{
            width: 28,
            height: 28,
            background: "linear-gradient(135deg, #1A6CF6, #6D28D9)",
            borderRadius: 7,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span
            style={{
              fontFamily: "Syne",
              fontWeight: 800,
              fontSize: 11,
              color: "#fff",
            }}
          >
            Nx
          </span>
        </div>
        <div>
          <div
            style={{
              fontFamily: "Syne, sans-serif",
              fontWeight: 700,
              fontSize: 13,
              color: "#fff",
            }}
          >
            NEXORA
          </div>
          <div
            style={{
              fontSize: 9,
              color: "rgba(255,255,255,0.25)",
              letterSpacing: "0.08em",
            }}
          >
            nexora.pentagonanalytics.io
          </div>
        </div>
      </div>
      <div style={{ fontSize: 12, color: "rgba(255,255,255,0.25)" }}>
        © {new Date().getFullYear()} Pentagon Analytics · All rights reserved
      </div>
      <div style={{ display: "flex", gap: 20 }}>
        {[
          { label: "Privacy", to: "/privacy" },
          { label: "Terms", to: "/terms" },
          { label: "Contact", to: "/contact" },
        ].map((link) => (
          <Link
            key={link.label}
            to={link.to}
            style={{
              fontSize: 12,
              color: "rgba(255,255,255,0.3)",
              textDecoration: "none",
              transition: "color 200ms",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#fff")}
            onMouseLeave={(e) =>
              (e.currentTarget.style.color = "rgba(255,255,255,0.3)")
            }
          >
            {link.label}
          </Link>
        ))}
      </div>
    </div>
  </footer>
);

export default SiteFooter;
